import { motion, useSpring } from "framer-motion";
import { useEffect, useRef } from "react";
import { Box } from "@mui/material";

// ✅ Use motion(Box) instead of component={motion.div}
const MotionBox = motion(Box);

export default function DragBall() {
    const ref = useRef(null);
    const { x, y } = useFollowPointer(ref);

    return (
        <MotionBox
            ref={ref}
            sx={{
                ...ballStyle,
            }}
            style={{ x, y }} // ✅ Use `style` instead of `animate`
        />
    );
}

const spring = { damping: 5, stiffness: 100, restDelta: 0.001 };

function useFollowPointer(ref) {
    const x = useSpring(0, spring);
    const y = useSpring(0, spring);

    useEffect(() => {
        if (!ref.current) return;

        const handlePointerMove = ({ clientX, clientY }) => {
            x.set(clientX - 10); // Centering the ball (80px width)
            y.set(clientY - 10);
        };

        window.addEventListener("pointermove", handlePointerMove);
        return () => window.removeEventListener("pointermove", handlePointerMove);
    }, []);

    return { x, y };
}

// 🎨 Styles
const ballStyle = {
    width: 15,
    height: 15,
    backgroundColor: "rgb(35, 168, 225) ",
    borderRadius: "50%",
    position: "fixed",
    pointerEvents: "none",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    zIndex: 9999,
};
